import React from "react";
import { ConfigProvider } from "antd";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";

const THEME = {
  token: { colorPrimary: "#fb310d", colorLink: "#fb310d", borderRadius: 8, fontFamily: '"Inter", sans-serif', controlHeight: 36 },
};

export default function HomeBannersLayout({ children }) {
  return (
    <div id="main-wrapper">
      <MainHeader />
      <Header name={"Home banners"} />
      <NavBar />
      <div className="content-body" style={{ minHeight: "100vh" }}>
        <div className="container-fluid" style={{ maxWidth: "1680px", margin: "0 auto", padding: "1.25rem" }}>
          <ConfigProvider theme={THEME}>{children}</ConfigProvider>
        </div>
      </div>
      <Footer />
    </div>
  );
}
